/** A shared introduction for new characters. Existing characters stay in the world. */
export const TUTORIAL_ZONE_ID = 'tutorial';
export const TUTORIAL_SET = [
    'wooden-sword',
    'wooden-shield',
    'bark-helm',
    'bark-chest',
    'wooden-gloves',
    'wooden-boots',
];
/**
 * The pieces the merchant hands over with his lesson (`grants`, bound): fewer
 * menus for a newcomer, who still wears each one.
 */
export const TUTORIAL_GIVEN = ['bark-chest', 'wooden-shield'];
/**
 * What the merchant sells and the player buys (ADR 0078): the set but the
 * sword, whose five copies the smelter hands over with his lesson, and the
 * merchant's own gifts.
 */
export const TUTORIAL_BOUGHT = TUTORIAL_SET.filter((id) => id !== 'wooden-sword' && !TUTORIAL_GIVEN.includes(id));
export const TUTORIAL_RESOURCE = 'rat-pelt';
/**
 * Three fights, one per rat of the training ground, finance the pieces
 * bought, the fusion and the first upgrade at ordinary prices.
 */
export const TUTORIAL_FIGHTS = 3;
/**
 * The smelter's lesson (ADR 0030): the tutor gives the swords that, with the
 * one bought, make five, and the player melts them into the rare one.
 */
export const TUTORIAL_FUSED_FROM = 'wooden-sword';
export const TUTORIAL_FUSED = 'wooden-sword-rare';
/** The smith's lesson: the rare sword taken to +1, which never fails (ADR 0013). */
export const TUTORIAL_UPGRADE_LEVEL = 1;
/** The smith's material, handed over with the smelter's lesson for that one attempt. */
export const TUTORIAL_UPGRADE_MATERIAL = 'flint';
/** The tutor: a warrior in the legendary frost set at +10, what a player can become. */
export const TUTOR_MOB_ID = 'tutor';
/** How close to the tutor a player must stand to be sent on ahead, diagonals included. */
export const TUTOR_REACH = 2;
/** The camp's quest whose turn-in opens the arch (ADR 0066, ADR 0078): the smelter's and smith's lesson. */
export const TUTORIAL_EXIT_QUEST = 'camp-fusion';
/** The camp's first quest: once it is turned in, its rats give no more experience (ADR 0078). */
export const TUTORIAL_HUNT_QUEST = 'camp-rats';
/** A camp creature's blows land at this share (ADR 0078): the camp teaches, it does not punish. */
export const TUTORIAL_MOB_DAMAGE_SHARE = 0.5;
//# sourceMappingURL=tutorial.js.map